export default __webpack_public_path__ + "static/media/bg-photo.53cfb2bb.png";